import { useState } from "react";
import { fmt } from "../lib/format";
import { TrendUp } from "@phosphor-icons/react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";

const AGGS = [
  { v: "sum", label: "Total" },
  { v: "avg", label: "Rata-rata" },
  { v: "min", label: "Minimum" },
  { v: "max", label: "Maksimum" },
];

export default function KpiCard({ numeric, defaultColumn, defaultAgg = "sum", label, index }) {
  const [column, setColumn] = useState(defaultColumn || (numeric[0]?.column ?? ""));
  const [agg, setAgg] = useState(defaultAgg);

  const metric = numeric.find((m) => m.column === column);
  const value = metric ? metric[agg] : null;
  const aggLabel = AGGS.find((a) => a.v === agg)?.label;

  return (
    <div className="rounded-2xl bg-card p-4 h-full flex flex-col justify-between shadow-sm ring-1 ring-black/[0.03] hover:ring-primary/20 transition-shadow"
      data-testid={`kpi-card-${index}`}>
      <div className="flex items-center justify-between gap-2">
        <Select value={column} onValueChange={setColumn}>
          <SelectTrigger className="h-7 border-0 bg-transparent px-0 text-xs uppercase tracking-widest text-muted-foreground focus:ring-0 shadow-none w-auto gap-1"
            data-testid={`kpi-column-${index}`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {numeric.map((m) => <SelectItem key={m.column} value={m.column}>{m.column}</SelectItem>)}
          </SelectContent>
        </Select>
        <TrendUp size={16} className="text-primary shrink-0" />
      </div>
      <div className="mt-3">
        <div className="font-display font-extrabold text-xl sm:text-2xl tracking-tight tabular truncate" title={value != null ? fmt(value) : "-"}>
          {value != null ? fmt(value) : "-"}
        </div>
        <div className="mt-2">
          <Select value={agg} onValueChange={setAgg}>
            <SelectTrigger className="h-6 border-0 bg-transparent px-0 text-xs text-muted-foreground focus:ring-0 shadow-none w-auto gap-1"
              data-testid={`kpi-agg-${index}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {AGGS.map((a) => <SelectItem key={a.v} value={a.v}>{a.label}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <span className="sr-only">{aggLabel}</span>
    </div>
  );
}
